import { render, staticRenderFns } from "./LoginXinhuaView.vue?vue&type=template&id=396cd661"
import script from "./LoginXinhuaView.vue?vue&type=script&lang=js"
export * from "./LoginXinhuaView.vue?vue&type=script&lang=js"
import style0 from "./LoginXinhuaView.vue?vue&type=style&index=0&id=396cd661&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports